__turbopack_context__.v({
  "container": "dropdown-menu-module__-Aywca__container",
  "content": "dropdown-menu-module__-Aywca__content",
  "dropdown": "dropdown-menu-module__-Aywca__dropdown",
  "heading": "dropdown-menu-module__-Aywca__heading",
  "item": "dropdown-menu-module__-Aywca__item",
  "itemDescription": "dropdown-menu-module__-Aywca__itemDescription",
  "itemLogo": "dropdown-menu-module__-Aywca__itemLogo",
  "list": "dropdown-menu-module__-Aywca__list",
  "srOnly": "dropdown-menu-module__-Aywca__srOnly",
  "swap": "dropdown-menu-module__-Aywca__swap",
  "technologiesShowcase": "dropdown-menu-module__-Aywca__technologiesShowcase",
});
